// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

export const strShimFunction = "function";
export const strShimObject = "object";
export const strShimUndefined = "undefined";
export const strShimPrototype = "prototype";
export const strDefault = "default";

export const ObjClass = Object;
export const ObjProto = ObjClass[strShimPrototype];
